import { render, staticRenderFns } from "./risk-assessment.vue?vue&type=template&id=b2132c94&scoped=true"
import script from "./risk-assessment.vue?vue&type=script&lang=js"
export * from "./risk-assessment.vue?vue&type=script&lang=js"
import style0 from "./risk-assessment.vue?vue&type=style&index=0&id=b2132c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2132c94",
  null
  
)

export default component.exports